
import {  Tabs } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import styles from './index.module.scss';
import { useConfigContext } from "@/app";

export const PageTabs = [
  {id: 'normal', title: '普通收付',  url: '/payment'},
  {id: 'merchant', title: '商家收付', url: '/payment/merchant' },
  {id: 'professionBusiness', title: '超级商家收付', url: '/payment/professionBusiness' },
]

export const ContentTabs = (props: {active: string}) => {
  const navigate = useNavigate();
  const { config } = useConfigContext();
  const onChange = (activeKey:string) =>  {
    
    const tab = PageTabs.find(tab => tab.id === activeKey);
    if(tab){
      navigate(tab.url, {replace: true});
    }
  }
  return <Tabs  activeKey={props.active} onChange={onChange} className={styles.tabs}>
  {PageTabs.map((Tab) => {
    if( config?.ProfessionStatus === "0" && Tab.id === "professionBusiness" ){
      return null;
    }else{
      return <Tabs.Tab title={Tab.title} key={Tab.id} destroyOnClose />;
    }
  })}
</Tabs>
}